import React from "react";
import { Target, Eye, ShieldCheck, Cpu, Award } from "lucide-react";

const CorporateAbout = () => {
  const values = [
    {
      icon: <ShieldCheck className="w-5 h-5" />,
      title: "Certified Inspection",
      desc: "ISO 9712 / ASNT qualified NDT inspectors",
    },
    {
      icon: <Cpu className="w-5 h-5" />,
      title: "Advanced NDT",
      desc: "PAUT, TOFD, UT, RT and digital reporting",
    },
    {
      icon: <Award className="w-5 h-5" />,
      title: "Industrial Experience",
      desc: "Refinery, Offshore, Shipyard, Fabrication",
    },
  ];

  return (
    <section
      id="about"
      className="py-20 md:py-32 px-4 sm:px-6 bg-white"
    >
      <div className="max-w-6xl mx-auto">


        {/* HEADER */}

        <div className="mb-16 md:mb-20">

          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-[2px] bg-orange-600" />
            <span className="text-orange-600 text-xs font-bold uppercase tracking-widest">
              About Focus NDT Group
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-6xl font-black text-slate-900">
            Industrial Inspection &
            <br />
            NDT Solutions
          </h2>

          <p className="text-slate-500 mt-4 max-w-xl text-sm">
            Focus NDT Group operates through Focus Inspection Technology
            and Focus NDT Innovations, providing industrial inspection,
            non-destructive testing, and software-based inspection
            solutions for oil & gas, offshore, fabrication,
            shipyard, and heavy engineering industries.
          </p>

        </div>



        {/* CONTENT */}

        <div className="flex flex-col lg:flex-row gap-12 items-center">


          {/* IMAGE */}

<div className="lg:w-1/2">

  <div className="grid grid-cols-2 gap-3">

    <img
      src="https://focusinspectiontechnology.com/images/Team.jpeg"
      alt="Inspection team"
      loading="lazy"
      className="w-full h-[200px] object-cover rounded-lg border border-slate-200"
    />

    <img
      src="https://focusinspectiontechnology.com/static/media/g2.8fca6d84898feff77fa1.jpeg"
      alt="NDT inspection"
      loading="lazy"
      className="w-full h-[200px] object-cover rounded-lg border border-slate-200"
    />

    <img
      src="https://focusinspectiontechnology.com/static/media/Integrity1.97a997f9be9f6c7dbfa7.jpeg"
      alt="Offshore work"
      loading="lazy"
      className="w-full h-[200px] object-cover rounded-lg border border-slate-200"
    />

    <img
      src="https://focusinspectiontechnology.com/static/media/mx2_scanner.2bb6d75b8c1d0780b16a.png"
      alt="Industrial inspection"
      loading="lazy"
      className="w-full h-[200px] object-cover rounded-lg border border-slate-200"
    />

  </div>

</div>



          {/* TEXT */}

          <div className="lg:w-1/2 space-y-6">

            <p className="text-slate-600 text-sm leading-relaxed">
              Focus NDT Group is an industrial inspection organization
              operating from India with global and offshore projects.
              The group provides Non-Destructive Testing (NDT),
              welding inspection, shutdown support, and digital
              inspection software solutions.
            </p>

            <p className="text-slate-600 text-sm leading-relaxed">
              Our team has extensive experience in UT, RT, MT, PT,
              PAUT, TOFD, pipeline inspection, structural inspection,
              pressure vessel testing, and asset integrity evaluation.
            </p>

            <p className="text-slate-600 text-sm leading-relaxed">
              With strong field expertise and modern technology,
              we deliver reliable inspection services, accurate reports,
              and high-quality support for critical industrial assets.
            </p>



            {/* MISSION / VISION */}

            <div className="grid md:grid-cols-2 gap-6 mt-6">

              <div className="p-6 border border-slate-200">

                <Target className="text-orange-600 mb-3" />

                <p className="text-xs font-bold uppercase text-slate-900">
                  Mission
                </p>

                <p className="text-xs text-slate-500 mt-2">
                  Provide reliable NDT and inspection services
                  with strict quality control and certified procedures.
                </p>

              </div>


              <div className="p-6 border border-slate-200">

                <Eye className="text-orange-600 mb-3" />

                <p className="text-xs font-bold uppercase text-slate-900">
                  Vision
                </p>

                <p className="text-xs text-slate-500 mt-2">
                  Become trusted global inspection and NDT
                  service provider combining field experience
                  with modern software technology.
                </p>

              </div>

            </div>



            {/* VALUES */}

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6">

              {values.map((v, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 border border-slate-200 p-4"
                >
                  <div className="text-orange-600">
                    {v.icon}
                  </div>

                  <div>
                    <p className="text-xs font-bold text-slate-900">
                      {v.title}
                    </p>
                    <p className="text-[10px] text-slate-500">
                      {v.desc}
                    </p>
                  </div>
                </div>
              ))}

            </div>

          </div>

        </div>



        {/* FOOT */}

        <div className="mt-20 text-center">

          <p className="text-slate-400 text-xs uppercase tracking-widest">
            Focus NDT Group • Inspection • Engineering • Software • Automation
          </p>

        </div>

      </div>
    </section>
  );
};

export default CorporateAbout;